import { render, staticRenderFns } from "./HelpAndFeedback.vue?vue&type=template&id=7c869be6&scoped=true&"
import script from "./HelpAndFeedback.vue?vue&type=script&lang=js&"
export * from "./HelpAndFeedback.vue?vue&type=script&lang=js&"
import style0 from "./HelpAndFeedback.vue?vue&type=style&index=0&id=7c869be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c869be6",
  null
  
)

export default component.exports